import React from 'react';
import styled from 'styled-components';
import { breakpoint } from '../styles/breakpoint';
import { makeBuildOptimizedSrc } from './ImageOptimizer';

class ProfileContainer extends React.PureComponent {
  render() {
    const { displayname, jobTitle, employer, picture } = this.props.profile;
    const imageUrl = makeBuildOptimizedSrc({
      width: 125,
      height: 125,
      format: 'auto'
    })(picture);
    const { handle } = this.props;
    return (
      <Container>
        <Avatar src={imageUrl} alt="" width="125" height="125" />
        <Name>{displayname}</Name>
        {jobTitle && <Title>{jobTitle}</Title>}
        {employer && <Company>{employer}</Company>}
        {handle && (
          <ViewProfileButton href={`https://learn.acloud.guru/profile/${handle}`} target="_blank" rel="noopener">
            View profile
          </ViewProfileButton>
        )}
      </Container>
    );
  }
}

const Container = styled.div`
  font-size: 60%;
  background-color: rgba(255, 255, 255, 0.08);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin: 2em 0;
  padding: 3em 2em;
  transition: all 0.2s;

  @media ${breakpoint.small} {
    font-size: 75%;
  }

  @media ${breakpoint.medium} {
    font-size: 100%;
  }

  @media ${breakpoint.large} {
    font-size: 75%;
    margin: 50px 0;
    padding: 2em;
    width: 32.5%;
    padding: 0 2em;
  }

  @media ${breakpoint.xlarge} {
    font-size: 100%;
  }
`;

const Avatar = styled.img`
  width: 7.8125em;
  height: 7.8125em;
  border-radius: 50%;
  border: 6px solid #fff;
  background-color: #ccc;
`;

const Name = styled.h1`
  color: #fff;
  font-weight: 400;
  font-size: 2.15em;
  margin: 0 0 0;
`;

const Title = styled.h2`
  color: #fff;
  font-weight: 200;
  font-size: 1.125em;
  letter-spacing: 0.04em;
  opacity: 0.75;
  margin: -0.25em 0 0;
`;

const Company = styled.span`
  color: #fff;
  opacity: 0.75;
  font-weight: 200;
  letter-spacing: 0.01em;
`;

const ViewProfileButton = styled.a`
  background-color: rgba(255, 255, 255, 0.1);
  text-transform: uppercase;
  font-weight: 200;
  font-size: 0.8em;
  letter-spacing: 0.125em;
  border: 0;
  border-radius: 30px;
  color: #fff;
  margin: 1.5em 0 0;
  padding: 1em 2.25em;
  cursor: pointer;
  outline: none;
  transition: background-color 0.2s;

  &:hover,
  &:focus {
    background-color: rgba(255, 255, 255, 0.15);
    color: #fff;
    text-decoration: none;
  }
`;

export default ProfileContainer;
